module.exports = __webpack_public_path__ + "media/images/menu/store-8be0d4cc07e556ac1f43aff0953e7be7.jpg";